import {
  Array,
  Boolean,
  Dictionary,
  Null,
  Number,
  Record,
  Static,
  String,
  Tuple,
  Union,
} from "runtypes";

import { DatetimeValue } from "./datetimeType.js";
import { FileTypeLiteral } from "./enums.js";
import { AppSessionFileId, FileId } from "./idTypeBrands.js";
import { TableInputData } from "./tableInputTypes.js";
import { JsonSerializedParameterValueContents } from "./typeBrands.js";

export const AllowedDynamicListValueTypes = Union(
  String,
  Number,
  Boolean,
  Null,
);
export type AllowedDynamicListValueTypes = Static<
  typeof AllowedDynamicListValueTypes
>;

export const DynamicList = Array(AllowedDynamicListValueTypes);
export type DynamicList = Static<typeof DynamicList>;

export const StringArray = Array(String);
export type StringArray = Static<typeof StringArray>;

export const NumberArray = Array(Number);
export type NumberArray = Static<typeof NumberArray>;

export const DatetimeValueTuple = Tuple(DatetimeValue, DatetimeValue);
export type DatetimeValueTuple = Static<typeof DatetimeValueTuple>;

export const FileUpload = Record({
  id: Union(FileId, AppSessionFileId),
  name: String,
  type: FileTypeLiteral,
});
export type FileUpload = Static<typeof FileUpload>;

export const UserAttributes = Dictionary(String, String);
export type UserAttributes = Static<typeof UserAttributes>;

export const ParameterValueContents = Union(
  String,
  Boolean,
  Null,
  Number,
  StringArray,
  NumberArray,
  DynamicList,
  TableInputData,
  DatetimeValue,
  DatetimeValueTuple,
  FileUpload,
  UserAttributes,
);
export type ParameterValueContents = Static<typeof ParameterValueContents>;

export const parseJsonSerializedParameterValueContents = (
  contents: JsonSerializedParameterValueContents,
): ParameterValueContents => {
  try {
    return JSON.parse(contents);
  } catch (err) {
    console.error(err);
    throw new Error(`Invalid serialized parameter value`);
  }
};

export const serializeParameterValueContents = (
  contents: ParameterValueContents,
): JsonSerializedParameterValueContents => {
  return JSON.stringify(contents) as JsonSerializedParameterValueContents;
};
